import { render, staticRenderFns } from "./CommentScoreCard.vue?vue&type=template&id=57e16012&scoped=true&lang=pug&"
import script from "./CommentScoreCard.vue?vue&type=script&lang=js&"
export * from "./CommentScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentScoreCard.vue?vue&type=style&index=0&id=57e16012&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e16012",
  null
  
)

export default component.exports